// Поддержка и апелляции — tech/03 §18 (E17-T04, E17-T07; заявка админки, Р-99): обращение из `SCR-SUPPORT` попадает в
// тикеты админки и в чат поддержки; апелляция на санкцию — в очередь апелляций (одна на санкцию, tech/06 §9).
import { z } from 'zod';
import { BigIdString, IsoTime, NextCursor, Uuid7, strict } from '../common.js';
import { endpoint } from '../endpoint.js';

export const TicketStatus = z.enum(['open', 'waiting_player', 'resolved', 'closed']);

export const createSupportTicket = endpoint({
  id: 'support.ticket.create', method: 'POST', path: '/support/tickets', auth: true, signed: true, idempotency: 'key-required', rate: 'write',
  body: strict({ subject: z.string().trim().min(1).max(200), body: z.string().trim().min(1).max(4000), orderId: Uuid7.optional() }),
  response: strict({ ticketId: BigIdString }), status: 201, errors: ['NOT_FOUND', 'DAILY_LIMIT'], spec: 'tech/03 §18; tech/10 §6', task: 'E17-T04',
});

export const getSupportTickets = endpoint({
  id: 'support.tickets', method: 'GET', path: '/support/tickets', auth: true, signed: false, idempotency: 'read', rate: 'read',
  query: strict({ cursor: z.string().max(64).optional() }),
  response: strict({
    items: z.array(strict({
      ticketId: BigIdString, subject: z.string(), status: TicketStatus, createdAt: IsoTime,
      messages: z.array(strict({ fromStaff: z.boolean(), text: z.string(), at: IsoTime })),
    })),
    nextCursor: NextCursor,
  }), status: 200, errors: [], spec: 'tech/03 §18', task: 'E17-T04',
});

export const createAppeal = endpoint({
  id: 'appeal.create', method: 'POST', path: '/appeals', auth: true, signed: true, idempotency: 'key-required', rate: 'write',
  body: strict({ sanctionId: BigIdString, text: z.string().trim().min(1).max(2000) }),
  response: strict({ appealId: BigIdString, status: z.literal('queued') }), status: 201, errors: ['NOT_FOUND', 'ALREADY_APPEALED'], spec: 'tech/03 §18; tech/06 §9', task: 'E17-T07',
});
